import { render, staticRenderFns } from "./ContactPopup.vue?vue&type=template&id=d2795f40&"
import script from "./ContactPopup.vue?vue&type=script&lang=js&"
export * from "./ContactPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports